import * as Yup from 'yup';
import { EMAIL_REGEX, isValidMobileNumber, extractNationalNumber } from 'utils';
import { getPasswordRules, validatePassword } from 'utils/passwordRules';

export interface ILoginSchema {
  loginWith: { label: string; value: string };
  email: string;
  mobilePhoneNumber: string;
  password: string;
}

const loginSchema = t =>
  Yup.object({
    loginWith: Yup.object({ label: Yup.string(), value: Yup.string() }),
    email: Yup.string()
      .matches(EMAIL_REGEX, {
        message: t('login.errors.invalidEmail'),
        excludeEmptyString: true,
      })
      .when('loginWith', {
        is: loginWith => loginWith.value === 'email',
        then: schema => schema.trim(t('login.errors.emailRequired')).required(t('login.errors.emailRequired')),
        otherwise: schema => schema.notRequired(),
      }),
    mobilePhoneNumber: Yup.string()
      .trim()
      .test('phone-required', t('login.errors.phoneNumberRequired'), function (value) {
        const { loginWith } = this.parent;
        if (loginWith.value !== 'mobilePhoneNumber') {
          return true;
        }
        const nationalNumber = extractNationalNumber(value);
        return !!(nationalNumber && nationalNumber.trim() !== '');
      })
      .test('mobilePhoneNumber-valid', t('login.errors.invalidPhoneNumber'), function (value) {
        const { loginWith } = this.parent;
        if (loginWith.value !== 'mobilePhoneNumber') {
          return true;
        }
        const nationalNumber = extractNationalNumber(value);
        if (!nationalNumber || nationalNumber.trim() === '') {
          return true;
        }
        return isValidMobileNumber(value);
      }),
    password: Yup.string()
      .required(t('login.errors.passwordRequired'))
      .test('password-validations', t('login.errors.invalidPassword'), function (value) {
        const rules = getPasswordRules(t).filter(rule => rule.key !== 'createPassword.passwordMatcher.rules.length');
        return validatePassword(value, {}, rules);
      }),
  }) as Yup.ObjectSchema<ILoginSchema>;

export default loginSchema;
